import { getDefaultHeader } from '../../services/serviceAPIHelper';

export function recoverPassword(user) {
    return fetch(process.env.REACT_APP_API_URL + 'user/' + user.user + '/recoverpassword', {
        headers:  getDefaultHeader(false),
        method: 'GET'
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw response;
        }
    });
}



// WEBPACK FOOTER //
// ./src/components/PasswordReminder/recoveryPasswordService.js